import { NgModule } from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {AuthGuard} from './guards/auth.guard';
import {UserSettingsComponent} from './user/user-settings/user-settings.component';
import {AdminPanelComponent} from './admin/admin-panel/admin-panel.component';
import { ScheduledEventsComponent } from './admin/scheduled-events/scheduled-events.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'grid',
    loadChildren: () => import('./grid/grid.module').then(m => m.GridModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'user',
    component: UserSettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    component: AdminPanelComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'scheduled-events',
    component: ScheduledEventsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'image-sync',
    loadChildren: () => import('./pages/image-sync/image-sync.module').then(m => m.ImageSyncModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'uploads',
    loadChildren: () => import('./pages/uploads/uploads.module').then(m => m.UploadsModule),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'logs',
  //   component: LogsComponent,
  //   // loadChildren: () => import('./logs/logs.module').then(m => m.LogsModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'login',
    component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
